import axiosInstance from "../../../utils/axiosInstance";
import { handleFrontendError } from "../../../utils/errorHandler";

export const SettingsApis = {
  // fetchUserStripeAccount: async (profile, token) => {
  //   try {
  //     const response = await axiosInstance.post(
  //       `/stripe/account-dashboard`,
  //       { accountId: profile.stripeAccountId },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     return response.data;
  //   } catch (error) {
  //     handleFrontendError(error, "There was an error");
  //   }
  // },

  updateStoreLogo: async (formData) => {
    try {
      const response = await axiosInstance.post(
        `/profile/update/store-logo`,
        formData
      );
      return response.data;
    } catch (error) {
      handleFrontendError(error, "There was an error");
    }
  },

  updateProfile: async (formDataToSend) => {
    try {
      const response = axiosInstance.post(
        `/profile/update/profile-info`,
        formDataToSend
      );
      return response.data;
    } catch (error) {
      handleFrontendError(error, "There was an error");
    }
  },

  passwordVerification: async (token) => {
    try {
      const response = axiosInstance.get(`/auth/verify-reset-token/${token}`);
      return response.data;
    } catch (error) {
      handleFrontendError(error, "There was an error");
    }
  },
};
